export default __webpack_public_path__ + "static/media/BlockChainDev.33ed5ef9.png";